import { render, staticRenderFns } from "./hotel.vue?vue&type=template&id=476acbb6&"
import script from "./hotel.vue?vue&type=script&lang=js&"
export * from "./hotel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\00_GIT\\hotel\\hotel-front-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('476acbb6')) {
      api.createRecord('476acbb6', component.options)
    } else {
      api.reload('476acbb6', component.options)
    }
    module.hot.accept("./hotel.vue?vue&type=template&id=476acbb6&", function () {
      api.rerender('476acbb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/coupon/hotel.vue"
export default component.exports